// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__MWkcz","main_logo":"MainNavigation_main_logo__2Kgc0","button_header":"MainNavigation_button_header__1JuZa"};